var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-msg-assistant" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-msg-assistant__content" },
      [
        _vm.isStreaming && !_vm.message.content
          ? _c(
              "div",
              { staticClass: "viq-msg-assistant__loading-bubble" },
              [_c("ViqMessageLoading")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.message.content
          ? _c("div", { staticClass: "viq-msg-assistant__card" }, [
              !_vm.isStreaming
                ? _c("div", { staticClass: "viq-msg-assistant__card-header" }, [
                    _c(
                      "div",
                      { staticClass: "viq-msg-assistant__card-header-left" },
                      [
                        _vm.citationsList.length > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "viq-msg-assistant__source-count",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.citationsList.length) +
                                    " source" +
                                    _vm._s(
                                      _vm.citationsList.length !== 1 ? "s" : ""
                                    ) +
                                    " identified\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "viq-msg-assistant__print-btn",
                        attrs: { title: "Download / Print" },
                        on: { click: _vm.printAnswer },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 14 14",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12 9v3H2V9M7 1v8M4 5l3 3 3-3",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viq-msg-assistant__card-body" },
                [
                  _c("div", {
                    staticClass: "viq-msg-assistant__body",
                    domProps: { innerHTML: _vm._s(_vm.renderedContent) },
                    on: { click: _vm.handleContentClick },
                  }),
                  _vm._v(" "),
                  !_vm.isStreaming &&
                  _vm.isLast &&
                  _vm.isClarifyingResponse &&
                  _vm.quickReplies.length > 0
                    ? _c("ViqFollowUps", {
                        attrs: {
                          suggestions: _vm.quickReplies,
                          "hide-header": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isStreaming && !_vm.isClarifyingResponse
                    ? _c("ViqFeedback", {
                        attrs: {
                          "message-id":
                            _vm.message.id || _vm.message.query_log_id,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isStreaming && _vm.citationsList.length > 0
                ? _c(
                    "div",
                    { staticClass: "viq-msg-assistant__sources" },
                    [
                      _c(
                        "div",
                        { staticClass: "viq-msg-assistant__sources-header" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.citationsList.length) +
                              " source" +
                              _vm._s(
                                _vm.citationsList.length !== 1 ? "s" : ""
                              ) +
                              " cited\n          "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top",
                                "open-delay": 300,
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "The specific sources used in this answer."
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "Click a source to view its full content."
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "viq-msg-assistant__help-icon" },
                                [_vm._v("?")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "viq-msg-assistant__sources-list" },
                        _vm._l(_vm.citationsList, function (c) {
                          return _c(
                            "div",
                            {
                              key: c.id,
                              staticClass: "viq-msg-assistant__source-card",
                              on: {
                                click: function ($event) {
                                  return _vm.openCitation(c)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "viq-msg-assistant__source-badges",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "viq-msg-assistant__source-badge",
                                      class: _vm.sourceTypeClass(c.source_type),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatSourceType(c.source_type)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  c.content_type
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "viq-msg-assistant__source-badge viq-msg-assistant__source-badge--type",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatContentType(
                                                c.content_type
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.classification
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "viq-msg-assistant__source-badge",
                                          class: _vm.classificationClass(
                                            c.classification
                                          ),
                                        },
                                        [_vm._v(_vm._s(c.classification))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "viq-msg-assistant__source-title",
                                },
                                [_vm._v(_vm._s(c.title))]
                              ),
                              _vm._v(" "),
                              c.jurisdiction
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "viq-msg-assistant__source-meta",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(c.jurisdiction) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      !_vm.isStreaming &&
                      _vm.message.expert_commentary &&
                      _vm.message.expert_commentary.length > 0
                        ? _c("ViqExpertCommentary", {
                            attrs: { articles: _vm.message.expert_commentary },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isStreaming && _vm.upsellJurisdictions.length > 0
                        ? _c("ViqUpsellJurisdictions", {
                            attrs: {
                              jurisdictions: _vm.upsellJurisdictions,
                              context: _vm.message.content
                                ? _vm.message.content.substring(0, 200)
                                : "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isStreaming && _vm.isLast && _vm.followUps.length > 0
                        ? _c("ViqFollowUps", {
                            attrs: { suggestions: _vm.followUps },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isStreaming && _vm.isLast && _vm.message.content
          ? _c("ViqActionChips", { attrs: { message: _vm.message } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "viq-msg-assistant__avatar" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/viq-avatar.png"),
          alt: "VIQ",
          width: "24",
          height: "24",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }